<template>
  <div class="c-len" :class="{ 'c-len-large': lenLarge }" :style="styleValue" @click="handleClick">
    <Input
      ref="input"
      class="c-input"
      v-model="data"
      :disabled="disabled"
      :placeholder="placeholder"
      :readonly="readonly"
      @on-keydown="keyEvent"
      @on-focus="$emit('on-focus')"
      @on-blur="itrim(data)"
    />
    <span class="c-length">
      <ins :class="{ 'c-text-err': lenStat }">{{ len }}</ins
      >/{{ max }}
    </span>
    <span v-if="!validate && isEmpty(value)" class="g-error-text">内容不能为空</span>
    <span v-else-if="!validate" class="g-error-text">超过了字符上限</span>
  </div>
</template>
<script>
import { getByteLen, trim, isArray, isEmpty, timeout } from '@/common/js/utils'
export default {
  name: 'clen',
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String]
    },
    max: {
      type: Number
    },
    bc: {
      type: Boolean,
      default() {
        return false
      }
    },
    charset: {
      type: String,
      default() {
        return 'gb2312'
      }
    },
    dynPos: {
      type: Array,
      default() {
        return []
      }
    },
    words: {
      type: Array,
      default() {
        return []
      }
    },
    verify: {
      type: Boolean
    }
  },
  computed: {
    data: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    styleValue() {
      return {
        width: `${this.width}px`
      }
    },
    dynct() {
      return isArray(this.dynPos) && this.dynPos.length
    },
    len() {
      let charLen
      let strLen
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const ten_regexp = /{{[a-z_]{2,}}}/g
      const data = String(this.data)
      const values = data.match(regexp)
      const tenVals = data.match(ten_regexp)
      const strTitle = data.replace(ten_regexp, '')
      if (this.charset === 'utf-8') charLen = 3
      else if (this.charset === 'init') charLen = 1
      else charLen = 2
      strLen = this.bc ? Math.ceil(getByteLen(strTitle) / charLen) : getByteLen(strTitle, charLen)
      // dynct
      if (isArray(values) && this.dynct) {
        values.forEach((ret) => {
          ret === '{定向包名}' && (strLen += 11)
          ret === '{创意组名}' && (strLen += 11)
          ret === '{策略名称}' && (strLen += 11)
          ret === '{素材名称}' && (strLen += 9)
        })
      } else if (isArray(values) && this.words) {
        values.forEach((ret) => {
          ret === '{节日}' && (strLen += 4)
          ret === '{日期}' && (strLen += 6)
          ret === '{地点}' && (strLen += 2)
        })
      } else if (isArray(tenVals)) strLen += 6
      return strLen
    },
    lenStat() {
      return this.len > this.max
    },
    lenLarge() {
      return this.max > 99
    },
    validate() {
      return this.verify ? !(isEmpty(this.value) || this.len > this.max) : true
    }
  },
  methods: {
    isEmpty,
    focus() {
      // Api public
      this.$refs.input.focus()
    },
    itrim(val) {
      val && this.$emit('input', trim(val))
      val && this.$emit('blur', trim(val))
      this.$emit('inputlen', this.len)
      this.$emit('on-blur', this.$refs.input.$refs.input.selectionStart)
    },
    // 点中动态词
    handleClick() {
      const input = this.$refs.input && this.$refs.input.$refs.input
      const { selectionStart } = input
      if (isArray(this.dynPos) && this.dynPos.length) {
        let val
        const getMid = (num, min, max) => {
          if (num > min && num < max) return max
          else return num
        }
        this.dynPos.some((ret) => {
          const [min, max] = ret
          val = getMid(selectionStart, min, max)
          return max === val
        })
        input.selectionStart = input.selectionEnd = val
      }
    },
    // 动态词 键盘监听
    keyEvent(e) {
      const input = this.$refs.input && this.$refs.input.$refs.input
      const { selectionStart } = input
      const getMax = (num, min, max) => {
        if (num === min) return max
        else return num
      }
      const getMin = (num, min, max) => {
        if (num === max) return min
        else return num
      }
      const getDelMax = (num, min, max) => {
        if (num === max) return [min, max]
        else return num
      }
      const getDelMin = (num, min, max) => {
        if (num === min) return [min, max]
        else return num
      }
      const getMid = (num, min, max) => num > min && num < max
      if (isArray(this.dynPos) && !this.dynPos.length) return
      if (e.keyCode === 37) {
        // left arrow
        let val
        this.dynPos.some((ret) => {
          const [min, max] = ret
          val = getMin(selectionStart, min, max)
          return min === val
        })
        if (selectionStart !== val) window.event.returnValue = false
        input.selectionStart = input.selectionEnd = val
      } else if (e.keyCode === 39) {
        // right arrow
        let val
        this.dynPos.some((ret) => {
          const [min, max] = ret
          val = getMax(selectionStart, min, max)
          return selectionStart !== max && max === val
        })
        if (selectionStart !== val) window.event.returnValue = false
        input.selectionStart = input.selectionEnd = val
      } else if (e.keyCode === 8) {
        // backspace
        let val
        const lock = this.dynPos.some((ret) => {
          const [min, max] = ret
          return getMid(selectionStart, min, max)
        })
        if (lock) window.event.returnValue = false
        this.dynPos.some((ret) => {
          const [min, max] = ret
          val = getDelMax(selectionStart, min, max)
          return isArray(val)
        })

        console.log('val output: ', val)
        // 发事件出去删除动态词
        if (isArray(val)) {
          const [min, max] = val
          input.selectionStart = min
          input.selectionEnd = max
          timeout(300).then(() => {
            this.$emit('on-del-trend')
          })
        }
      } else if (e.keyCode === 46) {
        // delete
        let val
        const lock = this.dynPos.some((ret) => {
          const [min, max] = ret
          return getMid(selectionStart, min, max)
        })
        if (lock) window.event.returnValue = false
        this.dynPos.some((ret) => {
          const [min, max] = ret
          val = getDelMin(selectionStart, min, max)
          return isArray(val)
        })
        if (isArray(val)) {
          const [min, max] = val
          input.selectionStart = min
          input.selectionEnd = max
          timeout(300).then(() => {
            this.$emit('on-del-trend')
          })
        }
      }
    }
  }
}
</script>
<style lang="scss">
.c-len {
  position: relative;
  height: inherit;
  display: inline-block;
  width: 100%;

  input {
    padding-right: 36px;
  }

  .c-length {
    position: absolute;
    right: 0;
    top: 0;
    padding: 0 4px;
    line-height: 32px;
    color: #8e8e8e;

    .c-text-err {
      color: #ff4900;
    }
  }

  &.c-len-large {
    input {
      padding-right: 50px;
    }
  }
}
</style>
